// Merged constants module derived from src/shared/utils/utilities.jsx,
// src/alive-academics/utils/utilities.js and src/alive-academics/utils/constants.js.
export const ERPLoginPageURL = 'https://www.acharyaerptech.in/Login'
// ERP_API_ENDPOINT only existed in shared/utils/utilities.jsx (not in alive-academics/utilities.js).
export const ERP_API_ENDPOINT = 'https://acerp.acharyaerptech.in'
export const ERPDashboardPageURL = 'https://www.acharyaerptech.in/Dashboard'
export const ERPStudentDashboardPageURL = 'https://student.acharyaerptech.in/dashboard'
export const ERPFacultyDashboardPageURL = 'https://faculty.acharyaerptech.in/dashboard'
export const ALIVE_SUPPORT_URL = 'https://support.alive.university'

export const ASSIGNMENT_CONVERT_DUE_TIME_BEFORE = '2026-01-20T18:30:00.000Z'

export const ACHARYA_EMAIL_PATTERN = /(([a-z0-9.]+)@acharya.ac.in)+/

export const SPACES_LOCATION_REGEXP = /(https:\/\/(?<bucket>[a-z-]+)\.)?(?<region>[a-zA-Z0-9]+)\.(cdn\.)?digitaloceanspaces\.com\/(?<key>(?<folder>[a-zA-Z_/-]+)\/(?<filesavedfullname>(\d{10,}\.)?(?<filefullname>[.a-zA-Z0-9@%()_-\s]+\.(?<fileextention>\w+))))\/?/

export const ALPHABETS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"

export const EMPTY_ARRAY = []
export const EMPTY_OBJECT = {}
// EMPTY_ARROW_FUNCTION only existed in shared/utils/utilities.jsx (not in alive-academics/utilities.js).
export const EMPTY_ARROW_FUNCTION = () => { }

export const DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thrusday', 'Friday', 'Saturday', 'Sunday']
export const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
export const WEEK_DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
export const HOURS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23']
export const DOC_VIEWER_SUPPORTED_FORMATS = ['mp4', 'webm', 'ogg', 'mp3', 'bmp', 'jpg', 'jpeg', 'docx', 'html', 'htm', 'doc', 'pdf', 'png', 'ppt', 'pptx', 'tiff', 'txt', 'xls', 'xlsx']

// From src/alive-academics/utils/constants.js
// Height value for study material description block, shows 'Show more' button if the content exceeds this height
// Type: INTEGER
export const STUDY_MATERIAL_DESCRIPTION_BLOCK_HEIGHT = 100

export const latexDelimiters = [
    { left: '$$', right: '$$', display: true },
    { left: '\\(', right: '\\)', display: false },
    { left: '$', right: '$', display: false },
    { left: '\\[', right: '\\]', display: true },
]

// quillDefaultModule only existed in alive-academics/utils/utilities.js
export const quillDefaultModule = {
    toolbar: {
        container: [
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ size: ['normal', 'small', 'large'] }],
            [{ align: [] }],
            [{ script: 'sub' }, { script: 'super' }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['link'],
            ['clean'],
            ['code-block'],
        ]
    },
}
